import { AlertTriangle } from 'lucide-react';

// Imported-template licensing surfaces (Batch 1, UI-only). Shown on templates that include
// VeriGRC-provided content (hub_template_id != null). These are INFORMATIONAL notices — nothing
// is recorded license-side; they are standing reminders of the license boundary. The caller
// gates on hub_template_id. Amber treatment (template-editing S1) for visibility — mirrors the
// app's established amber-notice pattern (SubmitWithEvidenceModal);
// existing accent-amber tokens only, readable body text on the amber-tinted surface.

export function ImportedLicenseBanner() {
  return (
    <div className="flex items-start gap-2.5 rounded-lg border border-accent-amber/40 border-l-4 border-l-accent-amber bg-accent-amber/10 p-3.5 text-sm text-text-secondary">
      <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0 text-accent-amber" />
      <p>
        This template includes content provided through VeriGRC. Your organization is responsible for
        ensuring that any use, modification, or added content stays within the applicable template license,
        the VeriGRC platform terms, and any rights your organization holds in content it adds.
      </p>
    </div>
  );
}

export function ImportedLicensePublishLine() {
  return (
    <p className="border-l-2 border-l-accent-amber/50 pl-2.5 text-xs text-text-muted max-w-2xl">
      Publishing your customized version does not change the license that applies to VeriGRC-provided content,
      or your organization&rsquo;s responsibility for any content it has added.
    </p>
  );
}
